import { render, staticRenderFns } from "./Splitter.vue?vue&type=template&id=14b124ca&"
import script from "./Splitter.vue?vue&type=script&lang=js&"
export * from "./Splitter.vue?vue&type=script&lang=js&"
import style0 from "./Splitter.vue?vue&type=style&index=0&id=14b124ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports